import { Badge } from '@/components/ui/badge';

export const AOP_META = {
  yes: { label: 'AOP: Yes', long: 'Yes – Existing AOP Member', cls: 'bg-emerald-50 text-emerald-800 border-emerald-300 dark:bg-emerald-900/30 dark:text-emerald-200' },
  no: { label: 'AOP: No', long: 'No – Not appearing as an existing AOP Member', cls: 'bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-200' },
  unconfirmed: { label: 'AOP: Unconfirmed', long: 'Unconfirmed – Requires verification', cls: 'bg-amber-50 text-amber-900 border-amber-300 dark:bg-amber-900/30 dark:text-amber-200' },
};

export const VERIFICATION_LABEL = {
  unverified: 'Not yet verified',
  confirmed_by_allottee: 'Confirmed by allottee',
  verified: 'Verified',
  disputed: 'Correction requested',
};

export function AopChip({ status, testid }) {
  const m = AOP_META[status];
  if (!m) return null;
  return <Badge variant="outline" className={`text-[10px] font-semibold ${m.cls}`} data-testid={testid}>{m.label}</Badge>;
}

export function OnFbcChip({ testid }) {
  return <Badge variant="outline" className="text-[10px] font-semibold bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-200" data-testid={testid}>On FBC</Badge>;
}
